import React, { useContext, useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import TopNavbar from '../../components/TopNavbar/TopNavbar';
import FullScreenStepper from '../../components/FullScreenStepper/FullScreenStepper';
import UserContext from '../Login/UserContext';
// Q_Cards replaced by ChoiceSelector in all steps
import { useMutation } from 'react-apollo';
import gql from 'graphql-tag';
import { updateUserMembers, updateUserAdultRole, updateUserFeltOnboardingComplete, updateUserIsRealFelter } from '../../graphql/mutations';
import ChoiceSelector from 'components/ChoiceSelector/ChoiceSelector';
import './FeltWelcome.scss';
import safeBuddyImg from 'assets/onboarding/felt_buddy.png';
import catbearsConflictImage from 'assets/onboarding/safe_environment.png';
import catbearsAllSetImage from 'assets/onboarding/catbears-all-set.png';
import feltLogoGlowing from 'assets/onboarding/felt-logo-glowing.png';
import RegisterCard from 'components/RegisterCard/RegisterCard';
import { track } from '../../utils/mixpanel';
import StickyFooter from 'components/StickyFooter/StickyFooter';

// Hoisted Step component to avoid remounts on parent re-renders (prevents duplicate Mixpanel events)
const Step = ({ stepName, title, children, showBack = false, onBack, onContinue, isContinueDisabled, beforeContinue, hideCTA = false, ctaText }) => {
  const { t } = useTranslation();
  useEffect(() => {
    try { track('APP_Felt_OB_View', { step: stepName, hasCTA: !hideCTA }); } catch (_) {}
  }, [stepName]);
  const containerRef = useRef(null);
  const [refresh, setRefresh] = useState(0);
  const handleContinue = async () => {
    if (beforeContinue) {
      try { await beforeContinue(); } catch (e) { console.error('beforeContinue failed', e); }
    }
    try { track('APP_Felt_OB_Submit', { step: stepName, hasCTA: !hideCTA }); } catch (_) {}
    onContinue && onContinue();
  };
  return (
    <div className="Onboarding-container " ref={containerRef}>
      <div className="Onboarding-content  FeltWelcome-container " onTransitionEnd={() => setRefresh((r)=>r+1)}>
        {/* <div className="Onboarding-title">{title}</div> */}
        <div className="Onboarding-content-container">
          {typeof children === 'function' ? children({ stepContinue: handleContinue }) : children}
        </div>
      </div>
          {!hideCTA && (
      <StickyFooter containerRef={containerRef} refresh={refresh} bottomSpacerHeight={0}>
        <div className="Onboarding-footer__content">
          {showBack && (
            <button onClick={onBack} className={"button Onboarding-button Onboarding-button-secondary catbearsCTA-secondary"}>
              {t('general.back') || 'Back'}
            </button>
          )}
            <button disabled={!!isContinueDisabled} onClick={handleContinue} className={"button Onboarding-button Onboarding-button-primary catbearsCTA-primary"}>
              {ctaText || t('general.continue') || 'Continue'}
            </button>
        </div>
      </StickyFooter>
          )}
    </div>
  );
};

const FeltWelcome = ({ authContext }) => {
  const [cheatsIsOn, setCheatsIsOn] = useState(false);

  const { t } = useTranslation();
  const { user, handleUserUpdate } = useContext(UserContext);
  const [selectedAge, setSelectedAge] = useState(null); // stores card id like 'age_3_5'
  const [setMembers] = useMutation(gql(updateUserMembers));
  const [setAdultRole] = useMutation(gql(updateUserAdultRole));
  const [setOnboardingComplete] = useMutation(gql(updateUserFeltOnboardingComplete));
  const [setIsRealFelter] = useMutation(gql(updateUserIsRealFelter));
  const [selectedGender, setSelectedGender] = useState(null); // 'boy' | 'girl'
  const [currentMemberId, setCurrentMemberId] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null); // 'parent' | 'teacher' | 'therapist' | 'other'
  const [isCheats, setIsCheats] = useState(true);
  const [whoIsUsing, setWhoIsUsing] = useState(null); // 'together' | 'me'

  const isOnboardingComplete = Boolean((authContext?.user?.isFeltOnboardingComplete) ?? (user?.isFeltOnboardingComplete));

  useEffect(() => {
    if (isOnboardingComplete && !cheatsIsOn) {
      window.location.replace('/felt');
    }
  }, [isOnboardingComplete, cheatsIsOn]);

  const onFinish = async () => {
    try {
      await setOnboardingComplete({ variables: { isFeltOnboardingComplete: true } });
      handleUserUpdate && handleUserUpdate({ isFeltOnboardingComplete: true });
    } catch (e) { console.error('Failed to set onboarding complete', e); }
    window.location.assign('/felt');
  }

  // Define steps as named constants for easy reordering
  const step_welcomeToFelt = (
    <Step key="welcomeToFelt" stepName="welcomeToFelt" title={t('feltOnboarding.welcomeToFeltTitle')}>
      {(ctx) => (
        <>
          <div className="informativeWithImage">
            <img className="feltLogoGlowingImage" src={feltLogoGlowing} alt="Felt - Felt Glow Logo" />
            <div className="Onboarding-title">{t('feltOnboarding.welcomeToFeltTitle')}</div>
            <p className="Onboarding-subtitle">{t('feltOnboarding.welcomeToFeltDescription')}</p>
            <p className="Onboarding-subtitle itsMuchEasierTo-title">{t('feltOnboarding.itsMuchEasierTo') + " "}</p>
            <ul className="informativeList-Container">
              <li className="Onboarding-subtitle">
                <p className="informativeBulletText">{t('feltOnboarding.itsMuchEasierTo_b1')}</p>
              </li>
              <li className="Onboarding-subtitle">
                <p className="informativeBulletText">{t('feltOnboarding.itsMuchEasierTo_b2')}</p>
              </li>
              <li className="Onboarding-subtitle">
                <p className="informativeBulletText">{t('feltOnboarding.itsMuchEasierTo_b3')}</p>
              </li>
            </ul>
          </div>
        </>
      )}
    </Step>
  );
  const step_adultRole = (
    <Step
      key="adultRole"
      stepName="adultRole"
      isContinueDisabled={!selectedRole}
      hideCTA
    >
      {(ctx) => (<>
        <div className="Onboarding-title">{t('feltOnboarding.adultRoleQuestion')}</div>
        <ChoiceSelector
          isMultipleSelection={false}
          isRandomize={false}
          isCards={true}
          defaultSelectedIds={selectedRole || undefined}
          isConfirmationNeeded={false}
          onSelect={(ids) => { const v = ids?.[0]; setSelectedRole(v); try { track('APP_Felt_OB_Select', { step: 'adultRole', value: v }); } catch (_) {} }}
          onConfirm={async (ids) => {
            const id = (Array.isArray(ids) ? ids[0] : ids) || selectedRole;
            try {
              await setAdultRole({ variables: { adultRole: id } });
              handleUserUpdate && handleUserUpdate({ adultRole: id });
              ctx.stepContinue();
            } catch (e) { console.error(e); }
          }}
          items={[
            { id: 'parent', displayString: t('feltOnboarding.role_parent'), emoji: '👩‍🍼' /* , image: '/assets/onboarding/adultRole_parent.svg' */ },
            { id: 'teacher', displayString: t('feltOnboarding.role_teacher'), emoji: '🧑‍🏫' /* , image: '/assets/onboarding/adultRole_teacher.svg' */ },
            { id: 'therapist', displayString: t('feltOnboarding.role_therapist'), emoji: '👩‍💼' /* , image: '/assets/onboarding/adultRole_therapist.svg' */ },
            { id: 'other', displayString: t('feltOnboarding.role_other'), emoji: '🦸‍♀️' /* , image: '/assets/onboarding/adultRole_other.svg' */ },
          ]}
        />
      </>)}
    </Step>
  );

  const step_childAge = (
    <Step
      key="childAge"
      stepName="childAge"
      showBack={false}
      isContinueDisabled={!selectedAge}
      hideCTA
    >
      {(ctx) => (
        <>
        <div className="Onboarding-title">{t('feltOnboarding.howOldIsChild')}</div>
        <ChoiceSelector
          isMultipleSelection={false}
          isRandomize={false}
          isCards={true}
          defaultSelectedIds={selectedAge || undefined}
          isConfirmationNeeded={false}
          onSelect={(ids) => { const v = ids?.[0]; setSelectedAge(v); try { track('APP_Felt_OB_Select', { step: 'childAge', value: v }); } catch (_) {} }}
          onConfirm={async (ids) => {
            const chosenId = (Array.isArray(ids) ? ids[0] : ids) || selectedAge;
            const ageMap = { age_3_5: '3-5', age_6_8: '6-8', age_9_10: '9-10', age_11_12: '11-12', age_13_plus: '13+' };
            const id = currentMemberId || `mem_${Date.now().toString()}_${Math.random().toString(36).slice(2,8)}`;
            const newMember = { id, ageRange: String(ageMap[chosenId]) };
            try {
              const existing = (authContext?.user?.members) || [];
              const next = [...existing, newMember];
              await setMembers({ variables: { members: next } });
              handleUserUpdate && handleUserUpdate({ members: next });
              setCurrentMemberId(id);
              ctx.stepContinue();
            } catch (e) { console.error(e); }
          }}
          items={[
            { id: 'age_3_5', displayString: `${t('feltOnboarding.age_3_5')}`, emoji: '🐥' },
            { id: 'age_6_8', displayString: `${t('feltOnboarding.age_6_8')}`, emoji: '🧒' },
            { id: 'age_9_10', displayString: `${t('feltOnboarding.age_9_10')}`, emoji: '👦' },
            { id: 'age_11_12', displayString: `${t('feltOnboarding.age_11_12')}`, emoji: '😎' },
            { id: 'age_13_plus', displayString: `${t('feltOnboarding.age_13_plus')}`, emoji: '👨🏼‍🎤' },
          ]}
        />
        </>
      )}
    </Step>
  );

  const step_whoIsUsing = (
    <Step
      key="whoIsUsing"
      stepName="whoIsUsing"
      hideCTA
    >
      {(ctx) => (
        <>
        <div className="Onboarding-title">{t('feltOnboarding.whoIsUsingQuestion')}</div>
        <ChoiceSelector
          isMultipleSelection={false}
          isRandomize={false}
          isCards={true}
          cardsLarge={true}
          defaultSelectedIds={whoIsUsing || undefined}
          isConfirmationNeeded={false}
          onSelect={(ids) => { const v = ids?.[0]; setWhoIsUsing(v); try { track('APP_Felt_OB_Select', { step: 'whoIsUsing', value: v }); } catch (_) {} }}
          onConfirm={async (ids) => {
            const id = (Array.isArray(ids) ? ids[0] : ids) || whoIsUsing;
            setWhoIsUsing(id);
            try {
              const isReal = id === 'together';
              await setIsRealFelter({ variables: { isRealFelter: isReal } });
              handleUserUpdate && handleUserUpdate({ isRealFelter: isReal });
            } catch (e) { console.error('Failed to set isRealFelter', e); }
            ctx.stepContinue();
          }}
          items={[
            { id: 'together', displayString: t('feltOnboarding.usingTogether'), emoji: '👩🧒' },
            { id: 'me', displayString: t('feltOnboarding.usingOnlyMe'), emoji: '👩' },
          ]}
        />
        </>
      )}
    </Step>
  );

  const step_gender = (
    <Step
      key="gender"
      stepName="gender"
      title={t('feltOnboarding.selectGender')}
      isContinueDisabled={!selectedGender}
      hideCTA
    >
      {(ctx) => (
        <>
        <div className="Onboarding-title">{t('feltOnboarding.selectGender')}</div>
        <ChoiceSelector
          isMultipleSelection={false}
          isRandomize={false}
          isCards={true}
          defaultSelectedIds={selectedGender || undefined}
          isConfirmationNeeded={false}
          onSelect={(ids) => { const v = ids?.[0]; setSelectedGender(v); try { track('APP_Felt_OB_Select', { step: 'gender', value: v }); } catch (_) {} }}
          onConfirm={async (ids) => {
            const chosenId = (Array.isArray(ids) ? ids[0] : ids) || selectedGender;
            try {
              const existing = (authContext?.user?.members) || [];
              let next = existing.slice();
              const idx = currentMemberId ? next.findIndex(m => m.id === currentMemberId) : next.length - 1;
              if (idx >= 0) { next[idx] = { ...next[idx], gender: chosenId }; }
              else {
                const id = `mem_${Date.now().toString()}_${Math.random().toString(36).slice(2,8)}`;
                next = [...next, { id, gender: chosenId }];
                setCurrentMemberId(id);
              }
              await setMembers({ variables: { members: next } });
              handleUserUpdate && handleUserUpdate({ members: next });
              ctx.stepContinue();
            } catch (e) { console.error(e); }
          }}
          items={[
            { id: 'boy', displayString: `${t('feltOnboarding.gender_boy')}`, emoji: '🚹' },
            { id: 'girl', displayString: `${t('feltOnboarding.gender_girl')}`, emoji: '🚺' },
            { id: 'other', displayString: `${t('feltOnboarding.gender_other')}`, emoji: '🚻' },
          ]}
        />
        </>
      )}
    </Step>
  );

  const step_buddyInfo = (
    <Step key="buddyInfo" stepName="buddyInfo" title={t('feltOnboarding.helpChildrenTellTitle')}>
      {(ctx) => (
        <>
          <div className="Onboarding-title">{t('feltOnboarding.helpChildrenTellTitle')}</div>
          <div className="informativeWithImage">
            <p className="Onboarding-subtitle">
              {(() => {
                const roleMap = {
                  parent: t('feltOnboarding.role_parent'),
                  teacher: t('feltOnboarding.role_teacher'),
                  therapist: t('feltOnboarding.role_therapist'),
                  other: ''
                };
                const r = roleMap[selectedRole] || '';
                const prefix = r ? `${r}, ` : '';
                return `${prefix}${t('feltOnboarding.buddyDescription')}`;
              })()}
            </p>
            <img className="informativeImage" src={safeBuddyImg} alt={t('feltOnboarding.buddyTitle')} />
          </div>
        </>
      )}
    </Step>
  );

  const step_safeEnvironment = (
    <Step key="safeEnvironment" stepName="safeEnvironment" title={t('feltOnboarding.safeEnvironmentTitle')}>
      {(ctx) => (
        <>
          <div className="Onboarding-title">{t('feltOnboarding.safeEnvironmentTitle')}</div>
          <div className="informativeWithImage">
            {/* <p className="safeEnvironmentDescription">{t('feltOnboarding.safeEnvironmentDescription')}</p> */}
            <p className="Onboarding-subtitle">{t('feltOnboarding.safeEnvironmentDisclaimer')}</p>
            <img className="informativeImage" src={catbearsConflictImage} alt={t('feltOnboarding.safeEnvironmentTitle')} />
          </div>
        </>
      )}
    </Step>
  );

  const step_createAccount = (
    <Step key="createAccount" stepName="createAccount" hideCTA>
      {(ctx) => (
        <>
          <div className="informativeWithImage">
            <img
              className="informativeImage createAccountImage"
              src={"/assets/icons/icon_feelings-are-private.svg"}
              alt="feelings are private"
            />
            <div className="Onboarding-title">{t('feltOnboarding.feltWelcomeCreateAccountTitle')}</div>
            <div className="Onboarding-subtitle">{t('feltOnboarding.feltWelcomeCreateAccountDescription')}</div>
            <RegisterCard isTitleInsideBox={true} onSuccess={() => { ctx.stepContinue(); }} />
          </div>
        </>
      )}
    </Step>
  );

  const step_allSet = (
    <Step key="allSet" stepName="allSet" title={t('feltOnboarding.allSetTitle')} ctaText={t('feltOnboarding.startFeltCta')} onContinue={() => { onFinish(); }}>
      {() => (
        <>
          <div className="informativeWithImage allSet__container">
            <img className="informativeImage" src={catbearsAllSetImage} alt="Catbears - Cat and Bear are getting ready to fire a firecracker to the sky" />
            <div className="Onboarding-title" style={{ marginBottom: 8 }}>{t('feltOnboarding.allSetTitle')}</div>
            <p className="Onboarding-subtitle">{t('feltOnboarding.allSetText')}</p>
          </div>
        </>
      )}
    </Step>
  );

  // Compose steps here for easy reordering
  const steps = [
    // do not delete this: step_welcomeToFelt,
    step_adultRole,
    step_whoIsUsing,
    step_buddyInfo,
    step_childAge,
    step_gender,
    step_safeEnvironment,
    // step_createAccount,
    step_allSet,
  ];

  
  return (
    <>
      {cheatsIsOn && (
      <div className="cheats-panel__wrapper">
        <div className="cheats-panel__bar">
          <label style={{ cursor: 'pointer', color: '#444', fontSize: 11 }}>
            <input type="checkbox" checked={isCheats} onChange={(e) => setIsCheats(e.target.checked)} /> Cheats
          </label>
        </div>
        {isCheats && (
          <div className="cheats-panel__content">
            <button
              onClick={() => { console.log('CHEATS user:', authContext?.user || user); }}
              className="cheats-panel__btn--primary"
            >
              Log user
            </button>
            <button
              onClick={async () => {
                try {
                  await setMembers({ variables: { members: [] } });
                  handleUserUpdate && handleUserUpdate({ members: [] });
                  console.log('CHEATS: all members deleted');
                } catch (e) { console.error('CHEATS delete members failed', e); }
              }}
              className="cheats-panel__btn--danger"
            >
              Delete all members
            </button>
            <button
              onClick={async () => {
                try {
                  await setOnboardingComplete({ variables: { isFeltOnboardingComplete: false } });
                  handleUserUpdate && handleUserUpdate({ isFeltOnboardingComplete: false });
                  console.log('CHEATS: isFeltOnboardingComplete set to false');
                } catch (e) { console.error('CHEATS reset onboarding flag failed', e); }
              }}
              className="cheats-panel__btn--primary"
            >
              Reset onboarding flag
            </button>
          </div>
          )}

        </div>
      )}
      <TopNavbar
        showNavBG={true}
        showLogo={false}
        title={t('feltOnboarding.welcomeToFeltTitle')}
        authContext={authContext}
        user={user}
        backgroundColor={'var(--color-skyblue)'}
        opacity={'0.93'}
        texture={true}
        showMenuButton
        showLangButton
        isFelt
        disableLogoLink
        isOnboarding
      />

      <FullScreenStepper steps={steps} onFinish={onFinish} />
      
    </>
  );
};

export default FeltWelcome;


